module.exports = __webpack_public_path__ + "img/import_img.f633f8a7.png";